module.exports = __webpack_public_path__ + "d0a83bbc11801ddb2cc615942d3be567.svg";